/*!
 * Stimpack Sync Height
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Decode } from '../utilities/utilities';

(function($){

    var spSyncHeight = function(options)
    {
        var _this = this;

        this.defaultOptions = {
            group           : null,
            root            : $('body'),
            selector        : '',
            property        : 'min-height',
            breakpoint      : false,
            updateOnResize  : true,
            resizeDelay     : 200
        };

        this.options = $.extend({}, this.defaultOptions, options);

        this.el = {
            root: typeof this.options.root === 'object' ? this.options.root : $(this.options.root)
        };

        if (this.options.updateOnResize)
        {
            this.resizeTimeout = 0;
            this.lastWidth = $(window).outerWidth();

            $(window).on('resize', function() {

                clearTimeout(_this.resizeTimeout);

                _this.resizeTimeout = setTimeout(function() {

                    var currentWidth = $(window).outerWidth();

                    if (_this.lastWidth !== currentWidth)
                    {
                        _this.lastWidth = currentWidth;
                        console.log('sync');
                        _this.sync();
                    }

                }, _this.options.resizeDelay);
            });
        }

        setTimeout(function() {
            _this.sync();
        }, 500);

        return this;
    };

    /*
     * Get Target
     */
    spSyncHeight.prototype.getTarget = function()
    {
        return this.el.root.find(this.options.selector);
    };

    /*
     * Sync
     */
    spSyncHeight.prototype.sync = function()
    {
        if (!this.options.breakpoint || spIsBreakpointReached(this.options.breakpoint))
        {
            var _this = this,
                maxHeight = 0,
                target = this.getTarget();

            target.css(this.options.property, 'auto');

            target.each(function() {

                var el = $(this);

                if (el.outerHeight() > maxHeight)
                {
                    maxHeight = el.outerHeight();
                }
            });

            target.css(_this.options.property, maxHeight);
        }
        else
        {
            this.getTarget().css(this.options.property, 0);
        }
    };

    /* -- */

    $.spSyncHeightGroups = {};

    $.fn.spSyncHeight = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-sync-height');

            if (_options)
            {
                if (spIsBase64(_options))
                {
                    _options = JSON.parse(spBase64Decode(_options));
                }
                else if (typeof _options == 'string')
                {
                    _options = {selector: _options};
                }

                options = (typeof _options == 'object') ? $.extend({}, options, _options) : options;
            }

            // If not a CSS selector, it's a group
            if (!options.selector.match(/[#.>]/i))
            {
                options.group = options.selector;

                if (!$.spSyncHeightGroups[options.group])
                {
                    options.selector = '[data-sp-sync-height="' + options.selector + '"]';
                    this.spSyncHeight = new spSyncHeight(options);
                    $.spSyncHeightGroups[options.group] = this.spSyncHeight;
                }
            }
            else
            {
                options.root = $(this);
                this.spSyncHeight = new spSyncHeight(options);
            }
        });
    };

    /* -- */

    $('[data-sp-sync-height]').spSyncHeight();

})(jQuery);
